import { Component } from '@angular/core';
import * as moment from 'moment';
import { ModelsService } from './shared/guard/model';
import { SelectItem } from './shared/controller/controller.service';
import { AlertModel, DeviceModel } from './core/alerts/model/alert.model';
import { TranslatePipe } from '@ngx-translate/core';
import { GetAlertRasonKey } from './shared/Constants';
import { GoToSearch } from './shared/guard/goToSearch';

export class IgnoreSensor {
  public static readonly None: number = 0x0;
  public static readonly Movement: number = 0x1;
  public static readonly MovementWithBattery: number = 0x2;
  public static readonly Temperature: number = 0x4;
  public static readonly BraceletCounter: number = 0x8;
  public static readonly CaseOpening: number = 0x10;
  public static readonly SendMacToGateWay: number = 0x20;
}

export class Monitor {
  public id: string | undefined;
  public connectionId: string | undefined;
  public state: number | undefined;
  public ticks: number | undefined;
  public timeOut: number | undefined;
}

export class MonitorState {
  public static readonly None: number = 0;
  public static readonly Connected: number = 1;
  public static readonly Disconnected: number = 2;
  public static readonly Free: number = 3;
  public static readonly Busy: number = 4;
  public static readonly Standby: number = 5;
  public static readonly Idle: number = 6;
}

export class AlertType {
  public static readonly None: number = 0;
  public static readonly Normal: number = 0;
  public static readonly Information: number = 1;
  public static readonly Supresion: number = 2;
  public static readonly Warning: number = 128;
  public static readonly Critical: number = 256;
}

export class AlertStates {
  public static readonly None: number = 0;
  public static readonly Pending: number = 1;
  public static readonly Assigned: number = 2;
  public static readonly Acepted: number = 3;
  public static readonly Processing: number = 4;
  public static readonly FinishedNoConfirmed: number = 254;
  public static readonly Finished: number = 255;
}

export class AlertPriority {
  public static readonly None: number = 0;
  public static readonly Emergency: number = 1;
  public static readonly Urgent: number = 2;
  public static readonly Supresion: number = 3;
  public static readonly Otros: number = 4;
  public static readonly Supervision: number = 5;
  public static readonly FalseAlarm: number = 255;
}

export function getDeviceType(type: any): string {
  switch (type) {
    case 1:
      return 'Bap';
    case 2:
      return 'Bap Virtual';
    case 3:
      return 'Gateway mkg3';
    case 4:
      return 'Gateway kg03';
    case 5:
      return 'Gateway bap';
    case 6:
      return 'URT Ggw01';
    case 8:
      return 'Bap';
  }
  return '';
}

export function padNumber(value: number, length: number): string {
  return value.toString().padStart(length, '0');
}

export function batteryPercent(bv: number) {
  const minVal = 3500;
  const maxVal = 4100;

  let percentage = ((bv - minVal) / (maxVal - minVal)) * 100;
  percentage = Math.min(Math.max(percentage, 0), 100);
  return percentage;
}

export const SMS_ICON =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"/></svg>';

export const sexos = [
  { id: 'X', label: 'No definido' },
  { id: 'M', label: 'Masculino' },
  { id: 'F', label: 'Femenino' },
  { id: 'O', label: 'Otro' },
];

export const levelRages = [
  { id: -1, label: 'No Configurado' },
  { id: 1, label: 'Rango 1' },
  { id: 2, label: 'Rango 2' },
  { id: 3, label: 'Rango 3' },
  { id: 4, label: 'Rango 4' },
  { id: 5, label: 'Rango 5' },
];

export const rangeDiasFromTo = 90;

export function getSignalLevel(rssi: any): number {
  if (rssi >= -70) return 1; // Excelente
  if (rssi >= -80) return 2; // Buena
  if (rssi >= -90) return 3; // Regular
  if (rssi >= -95) return 4; // Mala
  return 5; // Muy mala
}

export const statesAll: Array<SelectItem> = [
  { id: 'T', label: 'Todos' },
  { id: 1, label: 'STATES.STATE-1' },
  { id: 2, label: 'STATES.STATE-2' },
  { id: 3, label: 'STATES.STATE-3' },
  { id: 4, label: 'STATES.STATE-4' },
];

export const typeAlarma: Array<SelectItem> = [
  { id: 'T', label: 'Todos' },
  { id: AlertType.Normal, label: 'Normal' },
  { id: AlertType.Information, label: 'Información' },
  { id: AlertType.Supresion, label: 'Supresión' },
  { id: AlertType.Warning, label: 'Advertencia' },
  { id: AlertType.Critical, label: 'Crítica' }, // Corregido: "Critica" → "Crítica"
];

export const priorityAlarma: Array<SelectItem> = [
  { id: 'T', label: 'Todos' },
  { id: AlertPriority.Emergency, label: 'Emergencia' },
  { id: AlertPriority.Urgent, label: 'Urgencia' },
  { id: AlertPriority.Supresion, label: 'Supresión' },
  { id: AlertPriority.FalseAlarm, label: 'Falsa Alarma' },
  { id: AlertPriority.Supervision, label: 'Supervisión' },
  { id: AlertPriority.Otros, label: 'Otros' },
];

export const onlineOffline: Array<SelectItem> = [
  { id: 'T', label: 'Todos' },
  { id: 1, label: 'Conectado' },
  { id: 0, label: 'Desconectado' },
];

export const alarmOnOffState: Array<SelectItem> = [
  { id: 'T', label: 'Todos' },
  { id: 1, label: 'Alerta' },
  { id: 0, label: 'Normal' },
];

export const alarmAllState: Array<SelectItem> = [
  { id: 'T', label: 'Todos' },
  { id: 1, label: 'Alarma' },
  { id: 0, label: 'Normal' },
];

export const alarmCutOffState: Array<SelectItem> = [
  { id: 'T', label: 'Todos' },
  { id: 1, label: 'Abierta' },
  { id: 0, label: 'Cerrada' },
];

export const alarmState: Array<SelectItem> = [
  { id: 'T', label: 'Todos' },
  { id: AlertStates.Pending, label: 'Pendiente' },
  { id: AlertStates.Assigned, label: 'Asignada' },
  { id: AlertStates.Acepted, label: 'Aceptada' },
  { id: AlertStates.Processing, label: 'En Proceso' },
  { id: AlertStates.FinishedNoConfirmed, label: 'Finalizada sin confirmar' },
  { id: AlertStates.Finished, label: 'Finalizada' },
];

export const tipoNoticias: Array<SelectItem> = [
  { id: 1, label: 'Documentación' },
  { id: 2, label: 'Novedades' },
  { id: 3, label: 'Alarmas' },
  { id: 4, label: 'Noticias' },
];

export function getReason(reason: string): string {
  let alertReason = '';
  let arr = reason.split('\n');
  for (const element of arr) {
    if (element.replace(/\s+/g, '') != '') {
      let key = GetAlertRasonKey(element);
      let result = AppComponent.translate.transform(key);
      if (result == key) {
        result = element;
      }
      alertReason += result;
    }
  }
  return alertReason;
}

export function getMac(device: any) {
  return device.gatewayBraceletMac > ''
    ? device.gatewayBraceletMac
    : device.braceletMac;
}

export function getStatesAll(item: any): SelectItem | undefined {
  return statesAll.find((x) => x.id == item);
}

export function getTypeAlarm(item: any): SelectItem | undefined {
  return typeAlarma.find((x) => x.id == item);
}

export function getPriorityAlarma(item: any): SelectItem | undefined {
  return priorityAlarma.find((x) => x.id == item);
}

export function getOnlineOffline(item: any): SelectItem | undefined {
  return onlineOffline.find((x) => x.id == item);
}

export function getAlarmOnOffState(item: any): SelectItem | undefined {
  return alarmOnOffState.find((x) => x.id == item);
}

export function getAlarmCutOffState(item: any): SelectItem | undefined {
  return alarmCutOffState.find((x) => x.id == (item ?? 0));
}

export function getAlarmState(item: any): SelectItem | undefined {
  return alarmState.find((x) => x.id == item);
}

export function getSexo(sexo: string): string {
  if (sexo) {
    return sexos.find((x) => x.id == sexo)?.label ?? sexos[0].label;
  }
  return sexos[0].label;
}

export function getPriorityClass(alertPriority: any): string {
  let _class = 'gray';
  switch (alertPriority) {
    case AlertPriority.Emergency:
      _class = 'red';
      break;
    case AlertPriority.Urgent:
      _class = 'yellow';
      break;
    case AlertPriority.FalseAlarm:
      _class = 'blue';
      break;
    case AlertPriority.Supresion:
      _class = 'green';
      break;
    case AlertPriority.Supervision:
      _class = 'light-blue';
      break;
    case AlertPriority.Otros:
      _class = 'gray';
      break;
  }
  return _class;
}

export function getIcon(
  icon: string,
  htmlClass: string = 'material-icons',
  htmlStyle: string = '',
  htmlAttriburs: string = '',
  htmlTittle: string = '',
): string {
  htmlClass =
    htmlClass.indexOf('material-') == -1
      ? 'material-icons ' + htmlClass
      : htmlClass;
  htmlClass = `mat-icon notranslate mat-mdc-tooltip-trigger mat-ligature-font mat-icon-no-color ng-star-inserted ${htmlClass}`;
  return `<div title="${htmlTittle}" class="${htmlClass}" style="${htmlStyle}" ${htmlAttriburs}>
    ${icon}
  </div>`;
}

export function getDeviceStatus(
  device: DeviceModel | undefined | null = undefined,
  alert: AlertModel | undefined | null = undefined,
  userMarging: boolean = true,
): string {
  if ((alert?.state ?? 0) < AlertStates.FinishedNoConfirmed) {
    if (device != null && (device?.isOnline ?? false)) {
      let channel = '';

      if (device?.channel == 2) {
        channel = `[SMS]`;
      }

      let gatewayOnline = getIcon(
        (device?.isOnline ?? false) ? 'link' : 'link_off',
        '',
        '',
        '',
        'URT ' + ((device?.isOnline ?? false) ? 'Conectado' : 'Desconectado'),
      );

      let gatewayBattery = device?.gatewayBatteryPercent ?? 0;
      let gatewayAcc = getIcon(
        device?.gatewayBatteryState == 'main' ? 'power' : 'battery_alert',
        '',
        '',
        '',
        device?.gatewayBatteryState == 'main' ? 'Red eléctrica' : 'Batería',
      );

      let call = getIcon(
        device?.gatewayCallDir == 0
          ? 'phone_forwarded'
          : device?.gatewayCallDir == 1
            ? 'phone_callback'
            : 'call_end',
        '',
        '',
        '',
        (device?.gatewayCallDir ?? 255) < 2
          ? device?.gatewayCallNumber
          : 'Sin Llamada',
      );

      let alertType = device?.alertType ?? 0;
      let result = '';

      const channelPill =
        channel != ''
          ? `
<div class="flex-row pill-info ${userMarging ? '' : ''} gateway-${alertType}">
${channel}</div>`
          : '';

      switch (device?.type) {
        case 8:
          let braceletState = getIcon(
            (device?.braceletState ?? 0) == 0 ? 'link_off' : 'link',
            '',
            '',
            '',
            'US ' +
              ((device?.braceletState ?? 0) == 0
                ? 'Desconectado'
                : 'Conectado'),
          );

          let braceletAlarm = getIcon(
            (device?.braceletAlarm ?? 0) != 0
              ? 'notifications_active'
              : 'watch',
            '',
            '',
            '',
            'US ' + ((device?.braceletAlarm ?? 0) != 0 ? 'Alarma' : 'Normal'),
          );

          let braceletBatteryPercent =
            (device?.braceletState ?? 0) == 0
              ? ''
              : `${device?.braceletBatteryPercent}%`;

          result = `
            <div class="flex-row" style="gap: 8px;" >
              <div class="flex-row pill-info ${
                userMarging ? '' : ''
              } gateway-${alertType}">
                ${gatewayOnline}
                ${gatewayAcc}
                <div class='percent-div'>
                ${gatewayBattery}%
                </div>
              </div>
              <div class="flex-row pill-info ${
                userMarging ? '' : ''
              } gateway-${alertType}">
                ${braceletState}
                ${braceletAlarm}
                <div class='percent-div'>
                ${braceletBatteryPercent}
                </div>
              </div>
            </div>
            ${channelPill}`;
          break;
        default:
          let braceletTemperature = Math.round(
            Number(device?.braceletTemperature ?? 0),
          );

          let braceletTemperatureIcon =
            (device?.braceletTimeout ?? true)
              ? ''
              : `${padNumber(braceletTemperature, 2)}°C`;

          let braceletIsMove = device?.braceletIsMoving ?? false;
          let braceletMoveIcon =
            (device?.braceletTimeout ?? true)
              ? ''
              : getIcon(
                  braceletIsMove ? 'directions_run' : 'man',
                  '',
                  '',
                  '',
                  braceletIsMove ? 'En movimiento' : 'Detenido',
                );
          const wearPill =
            braceletTemperatureIcon + braceletMoveIcon > ''
              ? `
<div class="flex-row pill-info ${userMarging ? '' : ''} gateway-${alertType}">
<div class='percent-div'>${braceletTemperatureIcon}</div>${braceletMoveIcon}</div>`
              : '';

          let gatewayOpen = getIcon(
            ((device?.gatewayCaseOpen || device?.gatewayCaseCounterChange) ??
              false)
              ? 'lock_open_right'
              : 'lock',
            '',
            '',
            '',
            (device?.gatewayCaseOpen ?? false) ? 'URT Abierta' : 'URT Cerrada',
          );

          let gatewayMove = getIcon(
            'tablet',
            (device?.gatewayMoveAllow ?? false) ? 'shake' : '',
            '',
            '',
            (device?.gatewayMoveAllow ?? false) ? 'Movimiento' : 'Normal',
          );

          let braceletTimeout = getIcon(
            (device?.braceletTimeout ?? true) ? 'link_off' : 'link',
            '',
            '',
            '',
            'US ' +
              ((device?.braceletTimeout ?? true)
                ? 'Desconectado'
                : 'Conectado'),
          );

          let braceletCutoffTitle =
            (device?.braceletMacChange ?? false)
              ? 'Cambio de US'
              : (device?.braceletCutoff ?? false)
                ? 'Apertura de US'
                : 'Normal';

          let braceletCutoff =
            (device?.braceletTimeout ?? true)
              ? ''
              : getIcon(
                  (device?.braceletMacChange ?? false)
                    ? 'watch_vibration'
                    : (device?.braceletCutoff ?? false)
                      ? 'watch_off'
                      : 'watch',
                  'material-symbols-outlined',
                  '',
                  '',
                  braceletCutoffTitle,
                );

          let braceletVoltage =
            (device?.braceletTimeout ?? true)
              ? ''
              : `${batteryPercent(Number(device?.braceletVoltage ?? 0)).toFixed(
                  0,
                )}%`;

          let setRenge = Number(
            (device?.braceletLevelRssi ?? '-1') == '-1'
              ? '5'
              : device?.braceletLevelRssi,
          );

          let currentRenge =
            (device?.braceletTimeout ?? true)
              ? 6
              : (device?.braceletRssiLevel ?? -1) < 1
                ? getSignalLevel(device?.braceletRssi)
                : (device?.braceletRssiLevel ?? -1);

          let range =
            (device?.braceletTimeout ?? true)
              ? ''
              : getIcon(
                  'counter_' + currentRenge,
                  'material-symbols-outlined',
                  '',
                  '',
                  currentRenge <= setRenge
                    ? 'Rango ' + currentRenge
                    : 'Rango actual ' + currentRenge + ' | ' + setRenge,
                );
          result = `
            <div class="flex-row" style="gap: 8px;" >
              <div class="flex-row pill-info ${
                userMarging ? '' : ''
              } gateway-${alertType}">
                ${gatewayOpen}
                ${gatewayOnline}
                ${gatewayAcc}
                <div class='percent-div'>
                ${gatewayBattery}%
                </div>
                ${gatewayMove}
                ${call}
              </div>
              <div class="flex-row pill-info ${
                userMarging ? '' : ''
              } gateway-${alertType}">
                ${braceletTimeout}
                ${braceletCutoff}
                <div class='percent-div'>
                ${braceletVoltage}
                </div>
                ${range}
              </div>
              ${wearPill}
              ${channelPill}
            </div>`;
          break;
      }

      return result;
    } else {
      let result = `
      <div class="flex-row" style="gap: 8px;" >
        <div class="flex-row pill-info ${userMarging ? '' : ''} gateway-256">
          <div class='percent-div'>&nbsp;</div>
          ${getIcon('link_off')}
          <div class='percent-div'>&nbsp;</div>
        </div>
      </div>`;
      return result;
    }
  }
  return '';
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public static translate: TranslatePipe;

  constructor(
    public modelsService: ModelsService,
    public translate: TranslatePipe,
    public gotoSearch: GoToSearch,
  ) {
    moment.locale('es');
    AppComponent.translate = translate;
  }
}
